import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function NewsDetail() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/content/news/${id}`).then((r) => setItem(r.data)).catch(() => setErr(true));
  }, [id]);

  if (err) return <div className="cb-container py-24"><p className="text-slate-500">Article not found. <Link to="/news" className="gold-text">Back to news</Link></p></div>;
  if (!item) return <div className="cb-container py-24 text-slate-500">Loading…</div>;

  return (
    <article className="py-16 sm:py-24 bg-white">
      <div className="cb-container max-w-3xl">
        <Link to="/news" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#D8AE4E] mb-8" data-testid="news-back"><ArrowLeft size={16} /> All articles</Link>
        {item.category && <p className="overline mb-3">{item.category}</p>}
        <h1 className="font-serif font-bold text-3xl sm:text-4xl text-[#0B1D40] leading-tight">{item.title}</h1>
        <div className="flex items-center gap-3 text-sm text-slate-500 mt-4 mb-8">
          {item.author && <span>{item.author}</span>}
          {item.created_at && <span className="font-mono">{new Date(item.created_at).toLocaleDateString()}</span>}
        </div>
        {item.image && <img src={item.image} alt={item.title} className="w-full rounded-md mb-8 border border-slate-200" />}
        <div className="prose prose-invert max-w-none text-slate-700 leading-relaxed whitespace-pre-line">{item.body || item.excerpt}</div>
      </div>
    </article>
  );
}
